import * as cookie from 'js/lib/cookie';

/**
 * Mock Statsig initial values matching the InitializeResponseV1WithUpdates format.
 * This is returned when no server-injected values are available, allowing the SDK to
 * bootstrap with an empty but structurally valid evaluation response.
 * Make it a function so that ssr doesn't complain about context issue when calling cookie.get
 */
const mockStatsigInitialValues = () =>
  JSON.stringify({
    /* eslint-disable camelcase */
    feature_gates: {},
    dynamic_configs: {},
    layer_configs: {},
    has_updates: true,
    hash_used: 'djb2',
    /* eslint-enable camelcase */
    time: 0,
    user: {
      userID: undefined,
      customIds: {
        stableID: cookie.get('__204u') || '',
      },
    },
  });

declare global {
  interface Window {
    __STATSIG_INITIAL_VALUES__?: string;
  }
}

/**
 *  Gets initial values for StatsigBootstrapProvider. This is needed because the provider is used in both server and client components, and we need to fetch the initial values in both environments.
 * @TODO: ohazda: can server-renderer already ensure it's are JSON string, ideally to avoid stringification on the client side
 * @returns {string} - The initial values for StatsigBootstrapProvider, as a JSON string.
 */
const getInitialValues = (): string => {
  return window.__STATSIG_INITIAL_VALUES__ ?? mockStatsigInitialValues();
};

export default getInitialValues;
